/* eslint-disable */
import React, { useContext } from "react";
import { Link } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { deleteData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";

const LabelHeader = ({
  setDownloadExcel,
  records,
  blockRefSelected,
}) => {
  const { setReloadLabelList, setSuccess, setError, setNotificationString } =
    useContext(GlobalProvider);

  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  /* function to click download xls*/
  const handleDownloadClick = () => {
    setDownloadExcel(true);
    setTimeout(() => setDownloadExcel(false), 500);
  };

  //function for delete label
  const deleteLabelHandler = async () => {
    const checkboxes = document.querySelectorAll(
      'input[name="selectLabelRecord"]'
    );

    const checkedBoxes = Array.from(checkboxes).filter((cb) => cb.checked);
    if (checkedBoxes.length === 0) return;

    try {
      await Promise.all(
        checkedBoxes.map((checkbox) => {
          const requestUrl =
            url.API_BASEURL +
            url.API_DELETE_TAG +
            `/${checkbox.value}` +
            `?token=${token}`;
          return deleteData(requestUrl);
        })
      );

      setReloadLabelList(true);
      setSuccess(true);
      setNotificationString(t("Label has been deleted successfully"));
    } catch (error) {
      console.error(error.message);
      setError(true);
      setNotificationString(t("Something went wrong, please try again later"));
    }
  };

  return (
    <div className="filter-container d-flex flex-wrap align-items-center gap-2 border-bottom border-gray">
      {/* -------- toggle column button start -------- */}
      {/* <Link
        to="#"
        className="column-collapse btn btn-primary icon-btn mw-unset"
      >
        <span className="d-block material-symbols-outlined icon-fill">
          visibility
        </span>
      </Link> */}
      {/* -------- toggle column button end -------- */}

      {/* -------- download button start -------- */}
      <Link
        to="#"
        onClick={handleDownloadClick}
        className="download btn btn-primary icon-btn mw-unset"
      >
        <span className="d-block material-symbols-outlined">download</span>
      </Link>
      {/* -------- download button end -------- */}

      {/* ------------- showing records start ----------------- */}
      <p className="text-gray fw-medium ms-auto me-3">
        {t("Showing")}
        <span className="text-black ms-1">{records}</span> {t("Records")} -
        <span className="text-black ms-1" ref={blockRefSelected}>
          {" "}
          0{" "}
        </span>{" "}
        {t("Selected")}
      </p>
      {/* ------------- showing records end ----------------- */}
      {/* ----- refresh icon start ------ */}
      <Link
        to="#"
        className="filter-btn btn btn-primary icon-btn mw-unset "
        onClick={() => {
          setReloadLabelList(true);
          setSuccess(true);
          setNotificationString(t("The list has been refreshed successfully"));
        }}
      >
        <span className="d-block material-symbols-outlined">refresh</span>
      </Link>
      {/* ----- refresh icon end ------ */}

      {/* -------- add new label popip button start -------- */}
      <Link
        to="#addUpdateLabelPopup"
        data-bs-toggle="offcanvas"
        role="button"
        aria-controls="addLabelPopup"
        className="save-reservation btn btn-primary icon-btn mw-unset"
      >
        <span className="d-block material-symbols-outlined">add</span>
      </Link>
      {/* -------- add new label popip button end -------- */}

      {/* -------- dropdown button start -------- */}
      <div className="dropdown">
        <button
          className="btn btn-primary dropdown-toggle mw-unset"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Actions
        </button>
        <ul className="dropdown-menu border-0 shadow-lg">
          <li>
            <Link className="dropdown-item" to="#" onClick={deleteLabelHandler}>
              {t("Delete selected")}
            </Link>
          </li>
        </ul>
      </div>
      {/* -------- dropdown button end -------- */}
    </div>
  );
};

export default LabelHeader;
